import { Component } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import SigortaBand from "@/components/SigortaBand";
import Hizmetler from "@/components/Hizmetler";
import NedenBiz from "@/components/NedenBiz";
import Yorumlar from "@/components/Yorumlar";
import Galeri from "@/components/Galeri";
import InstagramStrip from "@/components/InstagramStrip";
import Iletisim from "@/components/Iletisim";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import RacingGame from "@/pages/RacingGame";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
          <div className="text-center">
            <p className="font-display text-2xl font-bold text-slate-900">Bir sorun oluştu</p>
            <p className="mt-2 text-slate-500">Lütfen sayfayı yenileyip tekrar deneyin.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const HomePage = () => (
  <SmoothScroll>
    <div className="min-h-screen bg-slate-50 font-body text-slate-900">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <SigortaBand />
        <Hizmetler />
        <NedenBiz />
        <Yorumlar />
        <Galeri />
        <InstagramStrip />
        <Iletisim />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  </SmoothScroll>
);

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/oyun" element={<RacingGame />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
